import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.scss';
import Home from './pages/Home';
import Room from './pages/Room';
import RoomsBanner from './pages/RoomsBanner';
import WaitingRoom from './pages/WaitingRoom';
import Alert from './components/Common/Alert';
import { isOpenAlertState, isOpenConfirmState, isOpenInputboxState, isOpenSelectboxState } from './atoms/common';
import { useRecoilState } from 'recoil';
import Confirm from './components/Common/Confirm';
import Selectbox from './components/Common/Selectbox';
import Inputbox from './components/Common/Inputbox';

function App() {
  const [isOpenAlert] = useRecoilState(isOpenAlertState);
  const [isOpenConfirm] = useRecoilState(isOpenConfirmState);
  const [isOpenSelectbox] = useRecoilState(isOpenSelectboxState);
  const [isOpenInputbox] = useRecoilState(isOpenInputboxState);

  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/chatting-app" component={Home} />
          <Route
            exact
            path="/chatting-app/waiting-room"
            component={WaitingRoom}
          />
          <Route exact path="/chatting-app/room/:id" component={Room} />
          <Route
            exact
            path="/chatting-app/rooms-banner"
            component={RoomsBanner}
          />
        </Switch>
      </Router>
      {isOpenAlert ? <Alert /> : null}
      {isOpenConfirm ? <Confirm /> : null}
      {isOpenSelectbox ? <Selectbox /> : null}
      {isOpenInputbox ? <Inputbox /> : null}
    </>
  );
}

export default App;
